<header nx-header>
  <nx-header-row
    class="header_container"
    (mouseenter)="onHoverToggleNonPolicy(false)"
  >
    <nx-header-brand class="menu_brand">
      <nx-link class="nx-margin-right-2m">
        <a (click)="redirectToSummary()">
          <figure nxFigure>
            <img src="../../../assets/img/logo.svg" />
          </figure>
        </a>
      </nx-link>
      <div class="container_flex_center header-desktop">
        <nx-link class="text_no_wrap"
          ><a href="https://www.allianz.com.my" target="_blank">{{
            "HEADER.ALLIANZ_MALAYSIA" | translate
          }}</a></nx-link
        >
        <nx-link
          class="text_no_wrap nx-margin-left-2m"
          tabindex="0"
          (click)="switchToAlpha()"
          (keydown.enter)="switchToAlpha()"
          >{{ "HEADER.ALPHA_PORTAL" | translate }}</nx-link
        >
      </div>
    </nx-header-brand>
    <nx-header-actions class="header-mobile">
      <nx-icon
        class="bar-icon cursor-pointer"
        name="bars"
        aria-hidden="true"
        tabindex="0"
        (click)="toggleMenu()"
        (keydown.enter)="toggleMenu()"
      ></nx-icon>
    </nx-header-actions>
    <nx-header-actions class="header-desktop">
      <div class="menu_name_admin std-ta-right">
        <span nxCopytext="medium">{{ userName$ | async }}</span>
        <br class="name-break" />
        <span
          class="font-grey nx-margin-left-3xs text_no_wrap"
          nxCopytext="small"
        >
          {{ lastLogin$ | async }}
        </span>
      </div>
      <div *ngIf="isAdmin$ == true">
        <span class="administrator-btn-desktop">
          <button
            nxButton="small secondary"
            style="margin-bottom: 0px"
            class="nx-margin-left-m"
            (click)="switchURL('SAT_ADMIN_MENU')"
            type="button"
          >
            {{ "HEADER.ADMINISTRATOR" | translate }}
          </button>
        </span>
      </div>
      <div class="border-line nx-margin-x-m"></div>
      <button nxPlainButton class="button_black" (click)="signOut()">
        <nx-icon
          name="export-and-share"
          class="rotate_logout_icon ndbx-icon nx-icon--export-and-share nx-margin-right-2xs cursor-pointer"
          nxIconPositionStart
          aria-hidden="true"
        >
        </nx-icon>
        <span nxCopytext="medium" class="text_no_wrap">{{
          "HEADER.SIGN_OUT" | translate
        }}</span>
      </button>
    </nx-header-actions>
  </nx-header-row>
  <nx-header-row class="header_border"> </nx-header-row>
  <nx-header-row class="bottom_header_menu header_container">
    <nx-header-brand class="welcom_last_login nx-margin-0 header-mobile">
      <div nxCopytext="medium" class="nx-margin-right-2xs">
        {{ userName$ | async }}
      </div>
      <div class="font-grey" nxCopytext="small">
        {{ lastLogin$ | async }}
      </div>
    </nx-header-brand>
    <nx-header-navigation *ngIf="showmenu">
      <nx-header-navigation-item class="header-mobile">
        <a nxHeaderLink (click)="switchToAlpha()">{{
          "HEADER.ALPHA_PORTAL" | translate
        }}</a>
        <hr />
      </nx-header-navigation-item>

      @for (menu of menuList; track menu) {
        @if (menu.menuId === "SA_MNPOLICIES") {
          <nx-header-navigation-item>
            <div
              [style.borderBottom]="
                isMobileScreen ? '1px solid #e1e1e1' : 'none'
              "
              [style.paddingRight]="isMobileScreen ? '32px' : '0'"
              class="nx-header__link policytab"
              nxMenuButton
              (click)="toggleParentMenu()"
              (keydown.enter)="toggleParentMenu()"
              (mouseenter)="
                isMobileScreen ? null : onHoverToggleParentMenu(true)
              "
              menuButtonType="root"
              [expandable]="!!menu.subMenu"
              nxMenuItem
              [expanded]="showParentMenu"
              tabindex="0"
              role="button"
            >
              <a class="policy" nxHeaderLink>{{ menu.description }}</a>
              <nx-icon
                class="cursor-pointer"
                name="chevron-down"
                size="s"
              ></nx-icon>
            </div>
            <div
              nxMenuItem
              *ngIf="menu.subMenu && showParentMenu"
              class="sub_menu"
              (mouseleave)="
                !isMobileScreen ? onHoverToggleNonPolicy(false) : null
              "
            >
              <div nxLayout="grid maxwidth nogutter">
                <div nxRow>
                  <div nxCol="12,12,12,3,3,3" class="nx-margin-bottom-m">
                    @for (
                      unifiedMenuItem of menuPolicyMgmt;
                      track unifiedMenuItem
                    ) {
                      @if (isUnifiedMenu(unifiedMenuItem.menuId)) {
                        @if (!unifiedMenuItem.hidden) {
                          <a
                            (click)="nav(unifiedMenuItem.link, unifiedMenuItem)"
                            >{{ unifiedMenuItem.description }}</a
                          ><br />
                        }
                      }
                    }
                  </div>
                  <div nxCol="12,12,12,4,4,4" class="nx-margin-bottom-m">
                    @for (
                      motorMenuItem of menuPolicyMgmt;
                      track motorMenuItem
                    ) {
                      @if (isMotorMenu(motorMenuItem.menuId)) {
                        <span class="nx-font-weight-semibold">{{
                          motorMenuItem.description
                        }}</span
                        ><br />
                        @for (
                          motorMenuSubItem of motorMenuItem.subMenu;
                          track motorMenuSubItem
                        ) {
                          @if (motorMenuSubItem.type === "M") {
                            @if (!motorMenuSubItem.subMenu) {
                              <a>{{ motorMenuSubItem.description }}</a
                              ><br />
                            } @else {
                              <a
                                class="padding_0 header_nested_sub_menu"
                                nxMenuButton
                                (click)="onClick(motorMenuSubItem)"
                                menuButtonType="root"
                                [expandable]="!!motorMenuSubItem.subMenu"
                                nxMenuItem
                                [expanded]="motorMenuSubItem.hidden"
                              >
                                <nx-icon
                                  nxMenuButtonIcon
                                  name="chevron-right"
                                  size="s"
                                  aria-hidden="true"
                                ></nx-icon>
                                {{ motorMenuSubItem.description }}
                              </a>
                              <div
                                nxMenuItem
                                *ngIf="
                                  motorMenuSubItem.subMenu &&
                                  motorMenuSubItem.hidden
                                "
                              >
                                <a
                                  class="nested_sub_menu"
                                  *ngFor="
                                    let submenu of motorMenuSubItem.subMenu
                                  "
                                  nxMenuLink
                                  (click)="
                                    open(submenu, motorMenuSubItem, menu)
                                  "
                                >
                                  {{ submenu.description }}
                                </a>
                              </div>
                            }
                          } @else {
                            @if (!motorMenuSubItem.hidden) {
                              <a
                                (click)="
                                  nav(motorMenuSubItem.link, motorMenuSubItem)
                                "
                                >{{ motorMenuSubItem.description }}</a
                              ><br />
                            }
                          }
                        }
                      }
                    }
                  </div>
                  <div nxCol="12,12,12,3,3,3" class="nx-margin-bottom-m">
                    @for (
                      nonMotorMenuItem of menuPolicyMgmt;
                      track nonMotorMenuItem
                    ) {
                      @if (isNonMotorMenu(nonMotorMenuItem.menuId)) {
                        <span class="nx-font-weight-semibold">{{
                          nonMotorMenuItem.description
                        }}</span
                        ><br />
                        @for (
                          nonMotorMenuSubItem of nonMotorMenuItem.subMenu;
                          track nonMotorMenuSubItem
                        ) {
                          @if (!nonMotorMenuSubItem.hidden) {
                            <a
                              (click)="
                                nav(
                                  nonMotorMenuSubItem.link,
                                  nonMotorMenuSubItem
                                )
                              "
                              >{{ nonMotorMenuSubItem.description }}</a
                            ><br />
                          }
                        }
                      }
                    }
                  </div>
                </div>
              </div>
            </div>
            <hr class="header-mobile" />
          </nx-header-navigation-item>
        } @else {
          <nx-header-navigation-item
            (mouseenter)="onHoverToggleNonPolicy(false)"
          >
            <a (click)="nav(menu.link, menu)" nxHeaderLink>{{
              menu.description
            }}</a>
            <hr class="header-mobile" />
          </nx-header-navigation-item>
        }
      }

      <nx-header-navigation-item class="header-mobile">
        <a
          class="color_dark_blue"
          (click)="openURL('https://www.allianz.com.my', '_blank', '')"
          nxHeaderLink
          >Allianz Malaysia</a
        >
        <hr />
      </nx-header-navigation-item>
      <nx-header-navigation-item class="header-mobile">
        <a nxHeaderLink>
          <button
            nxPlainButton
            class="button_black logout_btn_mobile"
            (click)="signOut()"
          >
            <nx-icon
              name="export-and-share"
              class="rotate_logout_icon ndbx-icon nx-icon--export-and-share cursor-pointer"
              nxIconPositionStart
              aria-hidden="true"
            ></nx-icon>
            {{ "HEADER.SIGN_OUT" | translate }}
          </button>
        </a>
        <hr />
      </nx-header-navigation-item>
    </nx-header-navigation>

    <nx-header-actions class="header-actions">
      <nx-icon
        (click)="switchURL('SAT_PROFILE_URL')"
        (keydown.enter)="switchURL('SAT_PROFILE_URL')"
        tabindex="0"
        name="user-o"
        size="s"
        class="nx-margin-s cursor-on cursor-pointer"
      ></nx-icon>
      @if (false) {
        <div class="notification-popover">
          <img
            class="notif-icon cursor-pointer"
            (click)="toggleNotification($event)"
            (keydown.enter)="toggleNotification($event)"
            tabindex="0"
            role="button"
            height="24px"
            width="24px"
            [src]="getNotificationIcon(unreadNotification$ | async)"
          />

          @if (isNotificationClicked) {
            <div class="notification-panel">
              <app-notification-sidebar
                (toggledNotification)="toggledNotification($event)"
              >
              </app-notification-sidebar>
            </div>
          }
        </div>
      }
    </nx-header-actions>
  </nx-header-row>
</header>
